import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from 'api/constants';
import { resolve } from 'api/resolve';
import { useProposalContext } from 'features/project-versioning/hooks/useProposalContext';

import { useProposalApi } from '../proposal-api';
import { type ProposalStatus } from '../types';

export const useGetAllProposals = (statuses: ProposalStatus[] = []) => {
  const { getAllProposals } = useProposalApi();
  const { projectId = '' } = useProposalContext();
  const { ALL_PROPOSALS } = QUERY_KEYS;

  return useQuery({
    queryKey: [ALL_PROPOSALS, projectId, statuses],
    queryFn: () => resolve(getAllProposals(projectId, statuses)),
    enabled: !!projectId
  });
};
